<br>
<div class="card card-default">
    <div class="card-header title_size">
    <h2 class="card-title">Edit Leads Details</h2>
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    
    <div class="card-body">

    <div class="row">
    <div class="col-md-6">

         <div class="form-group">
            <label>First Name</label><span class="error">{{NameAlert}}</span>
            <input type="text"  class="form-control"  [(ngModel)]="data.first_name" (ngModelChange)="valuechange1($event)">
        </div>

        <div class="form-group">
        <label>Contact 1</label><span class="error">{{MobileAlert}}</span>
        <input type="text" class="form-control"  [(ngModel)]="data.contact_1" (ngModelChange)="valuechange2($event)" >
        </div>

        <div class="form-group">
        <label>Email</label><span class="error">{{MobileAlert}}</span>
        <input type="text" class="form-control"  [(ngModel)]="data.email" (ngModelChange)="valuechange2($event)">
        </div>
     
    </div>
    <!---------------------------------------------next row-------------------------------------->
    <div class="col-md-6">
        
            
        <div class="form-group">
            <label>Last Name</label><span class="error">{{EmailAlert}}</span>
            <input type="email" class="form-control" [(ngModel)]="data.last_name"  (ngModelChange)="valuechange3($event)">
        </div>
       

            <div class="form-group">
                <label>Contact 2</label><span class="error">{{EmailAlert}}</span>
                <input type="email" class="form-control"  [(ngModel)]="data.contact_2" (ngModelChange)="valuechange3($event)">
            </div>
        </div>    
    </div>
        
         <!---------------------
          <div class="sucess" *ngIf="isShown">
            <span class="closebtn content" onclick="this.parentElement.style.display='none';">&times;</span> 
            {{alert}}
          </div><br>
----------------------------------->
<div class="alert alert-success alert-dismissible alertWidth" *ngIf="isShown">
    <button type="button" class="close" data-dismiss="alert" aria-hidden="true" (click)="shown()">×</button>
    <h4><i class="icon fas fa-check"></i> {{alert}}</h4>    
</div>

<button type="submit" class="btn btn-primary btn_allign" (click)="Submit();">Submit</button><br><br>
       <!-----
        <button class="left2"  mat-raised-button (click)="Submit();">
            <span>Submit Changes</span>
        </button>
   ----->
        
</div>
        
 

       

